<template>
  <div class="secretarias-topo">
    <div class="secretarias-topo-textos">
      <p class="secretarias-topo-textos__sigla">
        {{ secretaria.sigla || "" }}
      </p>
      <p class="secretarias-topo-textos__nome">
        {{ secretaria.titulo || "" }}
      </p>
    </div>

    <div class="secretarias-topo-fotos">
      <div class="secretarias-topo-fotos__left" v-if="secretaria.foto_pessoa">
        <div
          class="foto-background"
          :style="{ backgroundImage: `url(${secretaria.foto_pessoa})` }"
        ></div>
      </div>

      <div class="secretarias-topo-fotos__right" v-if="secretaria.foto_secretaria">
        <img :src="secretaria.foto_secretaria" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "secretarias-topo",
  props: {
    secretaria: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
};
</script>

<style lang="scss">
.secretarias-topo {
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--color-text-title-secondary);
  background: var(--background-color-light);
  height: 270px;
  width: 100%;
  text-align: left;

  &-textos {
    display: flex;
    padding: 20px;

    &__sigla {
      font-family: Poppins;
      font-weight: bold;
      font-size: calc(var(--font-size--extra-large) * 0.75);
      margin: 0;
    }

    &__nome {
      font-family: Poppins;
      font-weight: bold;
      font-size: calc(var(--font-size--default) * 2.4);
      margin: 0;
      padding-left: 20px;
    }
  }

  &-fotos {
    display: flex;
    align-items: flex-end;
    justify-content: end;
    height: 900px;

    &__left,
    &__right {
      margin-left: 10px;
    }

    &__left {
      .foto-background {
        width: 283px;
        height: 417px;
        border-radius: 15px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }

    &__right {
      img {
        height: 417px;
        width: 283px;
        border-radius: 15px;
        object-fit: cover;
        object-position: center;
      }
    }
  }
}

/* Responsividade */
@media only screen and (max-width: 1224px) {
  .secretarias-topo-fotos {
    height: 750px;

    &__left {
      .foto-background {
        width: 183px;
        height: 317px;
      }
    }

    &__right img {
      height: 317px;
      width: 183px;
    }
  }
}

@media only screen and (max-width: 990px) {
  .secretarias-topo {
    flex-direction: column;
    align-items: center;
    height: auto;

    &-textos {
      flex-direction: column;

      &__nome {
        text-align: center;
      }
    }

    &-fotos {
      flex-direction: column;
      align-items: center;
      height: auto;

      &__left,
      &__right {
        width: 100%;
        height: auto;
        margin-bottom: 10px;

        .foto-background {
          width: 95%;
          height: 357px;
        }

        img {
          width: 95%;
          height: 357px;
        }
      }
    }
  }
}

@media only screen and (max-width: 620px) {
  .secretarias-topo-fotos {
    flex-direction: column;
    align-items: center;

    &__left,
    &__right {
      .foto-background {
        width: 317px;
        height: auto;
        aspect-ratio: 2/3;
      }

      img {
        width: 317px;
        height: auto;
      }
    }
  }
}
</style>
